import { maritalStatusTypes } from "utils/helpers/dictionaries";

export const maritalStatusList: maritalStatusTypes[] = [
  maritalStatusTypes.married,
  maritalStatusTypes.single,
  maritalStatusTypes.divorced,
  maritalStatusTypes.widowed,
]